import React, { Component } from "react";
import { VersionModel } from "./helper/version/Version.model";
import { setVersion } from "./services/store/reducers/version/action";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Router from "./routes";
import Loading from "./components/Loading";
import VersionDAO from "./services/api/PosVersion";
import ServerDAO from "./services/api/Server";
import "./assets/css/main.css";
import "./assets/font/flaticon.css";
import Auth from "./services/api/Auth";
import {API} from "./services/Common";
import {ServerModel} from "./helper/version/Server.model";

/*
if (window.location.hostname != 'localhost' && window.location.protocol != 'https:' && window.location.protocol != 'file:')
{
    window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
}*/

class App extends Component {
    state = {
        versionModel: null
    };
    componentDidMount() {
        document.addEventListener("gesturestart", function (e) {
            e.preventDefault();
        });
        this.loadVersion();

        this.checkRedirect();
    }

    loadVersion = () => {
        VersionDAO.getVersion()
            .then((versionData) => {
                let newModel = new VersionModel(versionData);
                this.props.init(newModel);
                this.setState({ versionModel: newModel });
            })
            .catch((error) => {
                let defaultModel = new VersionModel();
                this.props.init(defaultModel);
                this.setState({ versionModel: defaultModel });
            });
    };

    loadServer = (restaurantID) => {
        return new Promise((resolve) => {
            ServerDAO.getServer(restaurantID)
                .then((serverData) => {
                    let newModel = new ServerModel(serverData);

                    resolve(newModel);
                })
                .catch((error) => {
                    let defaultModel = new ServerModel();

                    resolve(defaultModel);
                });
        });
    };

    checkRedirect = () => {
        let restaurantID = localStorage.getItem("partner_id");

        if(restaurantID && Auth.isLogin()){
            this.loadServer(localStorage.getItem("partner_id")).then((serverModel) => {
                let redirectUrl = this.redirectUrl();

                if (serverModel.new_pos && redirectUrl){
                    window.location = redirectUrl;
                }
            });
        }
    }

    redirectUrl = () => {
        let hosts = {
            "onemin-prod.herokuapp.com": "https://pos2.oneminorder.com",
            "onemin-staging.herokuapp.com": "https://pos2test.oneminorder.com",
            "backend-prod.oneminorder.hu": "https://pos2.oneminorder.com",
            "backend-prod.oneminorder.com": "https://pos2.oneminorder.com"
        };
        let ownHost = (new URL(API)).host;

        return hosts[ownHost];
    };

    render() {
        if (!this.state.versionModel) return <Loading />;

        return <Router version={this.state.versionModel} checkRedirect={this.checkRedirect} />;
    }
}
const mstp = () => ({});
const mapDispatchToProps = (dispatch) => ({
    init: (model) => dispatch(setVersion(model))
});

export default withRouter(connect(mstp, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js